// utils/windowWidthListener.js
export function listenToWindowWidth(onChange) {
  const handleResize = () => {
    const width = window.innerWidth;
    onChange(width);
  };

  // Initial trigger
  handleResize();

  // Add listener
  window.addEventListener('resize', handleResize);

  // Return cleanup function
  return () => {
    window.removeEventListener('resize', handleResize);
  };
}



// WEBPACK FOOTER //
// ./src/utils/windowWidthListener.js